import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        pages: '='
    },
    template: `
        <ul class="pagination" ng-if="vm.list.pagination.pageCount > 1">
            <li>
                <div ng-if="vm.isFirstPage()">{{ 'general.Previous' | translate }}</div>
                <button ng-if="!vm.isFirstPage()" ng-click="vm.changePage(vm.list.pagination.currentPage - 1)">{{ 'general.Previous' | translate }}</button>
            </li>
            <li ng-if="vm.hasMorePreviousPages()">
                <button class="page" href="" ng-click="vm.changePage(vm.rangeStart - 1)">...</button>
            </li>
            <li ng-repeat="page in vm.range">
                <button class="page" ng-class="{ active: page === vm.list.pagination.currentPage }" ng-click="vm.changePage(page)">{{ page }}</button>
            </li>
            <li ng-if="vm.hasMoreNextPages()">
                <button class="page" href="" ng-click="vm.changePage(vm.rangeEnd)">...</button>
            </li>
            <li>
                <div ng-if="vm.isLastPage()">{{ 'general.Next' | translate }}</div>
                <button ng-if="!vm.isLastPage()" ng-click="vm.changePage(vm.list.pagination.currentPage + 1)">{{ 'general.Next' | translate }}</button>
            </li>
        </ul>
    `
})
export default class {
    constructor ($scope, lodash) {
        this.lodash = lodash;
        this.PAGINATION_RANGE = this.pages ? this.pages : 5;
        this.buildRange();
        $scope.$watch('vm.list.loading', (oldValue, newValue) => {
            if (newValue) {
                this.buildRange();
            }
        });
    }
    buildRange () {
        this.rangeStart = this.getRangeStart(this.PAGINATION_RANGE);
        this.rangeEnd = this.getRangeEnd(this.PAGINATION_RANGE) + 1; // lodash.range does not include the ending number
        this.range = this.lodash.range(this.rangeStart, this.rangeEnd);
    }
    changePage (page) {
        this.list.pagination.currentPage = page;
        this.list.fetch();
    }
    isFirstPage () {
        return this.list.pagination.currentPage === 1;
    }
    isLastPage () {
        return this.list.pagination.currentPage === this.list.pagination.pageCount;
    }
    hasMorePreviousPages () {
        return this.rangeStart !== 1;
    }
    hasMoreNextPages () {
        return this.rangeEnd !== (this.list.pagination.pageCount + 1);
    }
    getRangeStart (offset) {
        const rangeStart = this.list.pagination.currentPage - offset;
        if (rangeStart < 1) {
            return 1;
        }
        return rangeStart;
    }
    getRangeEnd (offset) {
        const rangeEnd = this.list.pagination.currentPage + offset;
        if (rangeEnd >= this.list.pagination.pageCount) {
            return this.list.pagination.pageCount;
        }
        return rangeEnd;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pagination/index.js